
export default {
  name: 'ProductCardBadges',
  props: {
    badges: {
      type: Array,
      default: () => [],
    },
  },
}
